// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z3icK","col":"styles_col__2w3a0"};